import React from "react";
import iconCheckMark from "../assets/img/icon_checkmark_white.svg";
import Spinner from "./Spinner";

function AllProductsActionsBar(props) {
    return (
        <div className={`avatar-circle-box ${props.size} ${props.status}`}>
            <div className="inner-text">{props.innerText}</div>
            {props.size === "big" && <div className={`status ${props.status}`}>
                {
                    props.status === "success" ?
                        <img className="icon-checkmark" src={iconCheckMark} alt=""/>
                        : <div className="spinner" data-qa="spinner"><Spinner/></div>
                }</div>}
        </div>
    );
}

export default AllProductsActionsBar;
